module.exports = __webpack_public_path__ + "static/media/19.747b9cbd.png";